<template>
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-left py-0 my-10">
        <h2 class="fs-1x fw-bolder mb-10">Registro de Visitas</h2>
        <div class="row">
          <div class="col-md-5 row">
            <!-- tipo documento -->
            <div class="col-md-12 mt-3">
              <label class="form-label required">Tipo Visita:</label><br />
              <div class="form-check mb-2">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault1"
                  v-model="state.formData.tipo_visita"
                  value="INSTITUCIONAL"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  Insitucional
                </label>
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="radio"
                  name="flexRadioDefault"
                  id="flexRadioDefault2"
                  v-model="state.formData.tipo_visita"
                  value="PERSONAL"
                  checked
                />
                <label class="form-check-label" for="flexRadioDefault2">
                  Personal
                </label>
              </div>
            </div>
            <!-- tipo documento -->
            <div class="col-md-12 mt-3">
              <label class="form-label required">Tipo de Documento:</label>
              <select
                v-model="state.formData.tipo_documento"
                class="form-select fuente"
                aria-label="select"
                :change="requiredDisabled(state.formData.tipo_documento)"
                :disabled="isDisabled"
              >
                <option
                  v-for="(list, key) in documentTypeList"
                  :value="list.id_tipo_documento_identidad"
                  :key="key"
                >
                  {{ list.nombre_tipo_documento_identidad=='NO PORTA'?'SIN CONEXIÓN SEGIP':list.nombre_tipo_documento_identidad }}
                </option>
              </select>
            </div>
            <!-- numero de documento -->
            <div class="col-md-12 mt-3">
              <label class="form-label required">Número de Documento:</label>
              <input
                type="text"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.nro_documento.$error }"
                ref="nro_documento"
                id="nro_documento"
                v-model="state.formData.nro_documento"
                @keyup.enter="searchData('partial')"
                @input="
                  checkFieldEmpty(
                    $event,
                    state.formData.nro_documento,
                    'nro_doc'
                  )
                "
                @keyup.delete="resetData()"
              />
              <span class="text-danger" v-if="v$.formData.nro_documento.$error">
                Número de Documento requerido
              </span>
            </div>
            <!-- complemento -->
            <div class="col-md-9 mt-3">
              <label class="form-label">Complemento:</label>
              <input
                type="text"
                class="form-control fuente"
                style="text-transform: uppercase"
                id="complemento"
                :disabled="registroManual"
                v-model="state.formData.complemento"
              />
            </div>
            <!-- botones de búsqueda y vaciado -->
            <div class="col-md-3 col-sm-12 mt-4">
              <button
                type="button"
                style="margin-top: 14px"
                class="btn px-3"
                :disabled="!state.formData.nro_documento"
                @click="searchData('partial')"
              >
                <i
                  title="Realizar búsqueda"
                  style="font-size: 1.5em; color: Dodgerblue"
                  class="fas fa-magnifying-glass"
                ></i>
              </button>
              <button
                type="button"
                style="margin-top: 14px"
                class="btn px-3"
                @click="resetData()"
              >
                <i
                  title="Vaciar campos"
                  style="font-size: 1.5em; color: red"
                  class="fas fa-trash"
                ></i>
              </button>
            </div>
          </div>
          <!-- card datos visita -->
          <div class="col-md-7 m-3">
            <div class="card-wrap h-100 my-4 row col-md-12 col-sm-12 mt-4">
              <p><strong> DATOS DEL VISITANTE:</strong></p>
              <div class="col-md-4">
                <img
                  v-if="state.formData.imagen_segip"
                  :src="state.formData.imagen_segip"
                  class="img-fluid img-thumbnail rounded mx-auto d-block"
                  width="150"
                  height="150"
                  alt="SegipImage"
                />
                <img
                  v-else
                  :src="personImg"
                  class="img-fluid img-thumbnail rounded mx-auto d-block"
                  width="150"
                  height="150"
                  alt="SegipImage"
                />
                <div
                  v-if="registroManual"
                  @click="openModalPicture()"
                  class="d-flex justify-content-center"
                >
                  <button class="btn btn-success btn-sm mt-1 p-2">
                    Añadir Imagen
                  </button>
                </div>
              </div>
              <div class="col-md-8 pt-3">
                <p>
                  <strong>NOMBRE :</strong>
                  {{ state.formData.nombres.toUpperCase() }}
                  {{ state.formData.primer_apellido.toUpperCase() }}
                  {{ state.formData.segundo_apellido.toUpperCase() }}
                </p>
                <p>
                  <strong>N° DE DOCUMENTO :</strong>
                  {{ state.formData.nro_documento }}
                  {{ state.formData.complemento }}
                </p>
                <!-- fecha visita -->
                <strong>FECHA Y HORA DE VISITA : </strong>
                {{ formatDateAndHours(state.formData.fecha_visita) }}
              </div>
            </div>
          </div>
        </div>
        <!-- registro manual -->
        <div class="row">
          <div class="row" v-if="registroManual">
            <div class="col-md-6 mt-5">
              <label class="form-label required">Nombres:</label>
              <input
                type="text"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.nombres.$error }"
                style="text-transform: uppercase"
                ref="nombre_id"
                id="nombre_id"
                v-model.trim="state.formData.nombres"
                v-uppercase
              />
              <span class="text-danger" v-if="v$.formData.nombres.$error">
                El registro del nombre es requerido
              </span>
            </div>
            <div class="col-md-6 mt-5">
              <label class="form-label required">Primer Apellido:</label>
              <input
                type="text"
                class="form-control fuente"
                style="text-transform: uppercase"
                ref="primer_apellido"
                id="primer_apellido"
                v-model.trim="state.formData.primer_apellido"
                v-uppercase
              />
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label required">Segundo Apellido:</label>
              <input
                type="text"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.segundo_apellido.$error }"
                style="text-transform: uppercase"
                ref="segundo_apellido"
                id="segundo_apellido"
                v-model="state.formData.segundo_apellido"
                v-uppercase
              />
              <span
                class="text-danger"
                v-if="v$.formData.segundo_apellido.$error"
              >
                El registro del apellido es requerido
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label required">Fecha Nacimiento:</label>
              <Datepicker
                uid="fecha_nacimiento"
                v-model="state.formData.fecha_nacimiento"
                type="date"
                locale="es"
                cancelText="Cancelar"
                selectText="Seleccionar"
                monthNameFormat="long"
                :enableTimePicker="false"
                :format="format"
                :previewFormat="format"
                :maxDate="currentDate"
                required
                class="form-select fuente"
                :class="{ 'is-invalid': v$.formData.fecha_nacimiento.$error }"
              ></Datepicker>
              <span
                class="text-danger"
                v-if="v$.formData.fecha_nacimiento.$error"
              >
                La Fecha de Nacimiento es requerida
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label required">Género:</label>
              <select
                v-model="state.formData.genero"
                class="form-select fuente"
                aria-label="select"
                :class="{ 'is-invalid': v$.formData.genero.$error }"
              >
                <option value="MASCULINO">MASCULINO</option>
                <option value="FEMENINO">FEMENINO</option>
              </select>
              <span class="text-danger" v-if="v$.formData.genero.$error">
                El registro Género es requerido
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label required">País:</label>
              <select
                v-model.trim="state.formData.pais"
                class="form-select fuente"
                aria-label="select"
                style="text-transform: uppercase"
                :class="{ 'is-invalid': v$.formData.pais.$error }"
              >
                <option
                  v-for="(list, key) in countriesOrdered"
                  :value="list.name"
                  :key="key"
                >
                  {{ list.name }}
                </option>
              </select>
              <span class="text-danger" v-if="v$.formData.pais.$error">
                El registro País es requerido
              </span>
            </div>
            <div class="col-md-6 mt-3">
              <label class="form-label required"
                >Departamento/Estado/Ciudad:</label
              >
              <input
                type="text"
                class="form-control fuente"
               
                style="text-transform: uppercase"
                ref="departamento"
                id="departamento"
                v-model="state.formData.departamento"
                v-uppercase
              />
              <!-- :class="{ 'is-invalid': v$.formData.departamento.$error }" -->
              <!-- <span class="text-danger" v-if="v$.formData.departamento.$error">
                El registro Departamento/Estado/Ciudad es requerido
              </span> -->
            </div>
          </div>
        </div>
        <!-- si no encuentra datos en el segip -->
        <div v-if="sinRegistroSegip" class="row mt-10">
          <p class="round4">
            Verifique el número de documento de identidad, no se encuentra
            registro en el SEGIP
          </p>
        </div>
        <!--búsqueda de persona privada de libertad a visitar -->
        <div v-if="!visitaActiva">
          <div v-if="state.formData.tipo_visita == 'PERSONAL'" class="row">
            <div class="col-md-10 mt-5">
              <label class="form-label"
                >Búsqueda de Persona Privada de Libertad:</label
              >
              <input
                type="text"
                class="form-control fuente"
                style="text-transform: uppercase"
                id="dato"
                v-model="dato_busqueda"
                @keyup.enter="searchPpl(dato_busqueda)"
                @input="checkFieldEmpty($event, dato_busqueda, 'dato_ppl')"
              />
            </div>
            <div class="col-md-2 col-sm-12 mt-7">
              <button
                type="button"
                style="margin: 5px"
                class="btn px-3"
                :disabled="!dato_busqueda"
                @click="searchPpl(dato_busqueda)"
              >
                <i
                  title="Realizar búsqueda de Ppl"
                  style="font-size: 1.5em; color: Dodgerblue"
                  class="fas fa-magnifying-glass"
                ></i>
              </button>
              <button
                type="button"
                style="margin: 10px"
                class="btn px-3"
                @click="
                  (dato_busqueda = ''),
                    (resultados = []),
                    (state.formData.id_parentesco = ''),
                    (state.formData.id_persona = ''),
                    (state.formData.id_recinto_penitenciario = ''),
                    v$.$reset()
                "
              >
                <i
                  title="Vaciar campos"
                  style="font-size: 1.5em; color: red"
                  class="fas fa-trash"
                ></i>
              </button>
            </div>
          </div>
          <!-- lista de ppls -->
          <div
            v-if="
              state.formData.tipo_visita === 'PERSONAL' && resultados.length > 0
            "
            class="row"
          >
            <table>
              <caption v-if="resultados.length > 0" style="caption-side: top">
                {{
                  resultados.length === 1 ? "Existe" : "Existen"
                }}
                {{
                  resultados.length
                }}
                {{
                  resultados.length === 1
                    ? "coincidencia"
                    : " posibles coincidencias"
                }}
              </caption>
              <thead>
                <tr>
                  <th>IMAGEN PPL</th>
                  <th>NOMBRE PPL</th>
                  <th>N° DOCUMENTO</th>
                  <th>RECINTO PENITENCIARIO</th>
                  <th>DELITO</th>
                  <th>PAIS</th>
                  <th>N° VISITAS</th>
                  <th>SELECCIONAR</th>
                </tr>
              </thead>
              <tbody>
                <td v-if="resultados.length == 0 && !isLoading" colspan="8">
                  Sin datos que mostrar
                </td>
                <td v-else-if="resultados.length == 0 && isLoading" colspan="8">
                  Cargando...
                </td>
                <tr v-else v-for="dato in resultados" :key="dato.id_persona">
                  <td data-column="IMÁGEN PPL">
                    <img
                      v-if="dato.imagen_segip !== 'null'"
                      :src="dato.imagen_segip"
                      alt="imagen_segip"
                      width="100"
                      height="100"
                    />
                    <img
                      v-else
                      src="../../../public/media/blank.png"
                      class="img-fluid img-thumbnail"
                      width="100"
                      height="100"
                      alt="without_image"
                    />
                  </td>
                  <td data-column="NOMBRE PPL">{{ dato.nombre_completo }}</td>
                  <td data-column="N° DOCUMENTO">{{ dato.nro_doc }}</td>
                  <td data-column="RECINTO">
                    {{ dato.nombre_recinto_penitenciario }}
                  </td>
                  <td data-column="DELITO">{{ dato.descripcion_delito }}</td>
                  <td data-column="PAÍS">{{ dato.pais }}</td>
                  <td data-column="N° VISITAS">{{ dato.nro_visitas }}</td>
                  <td data-column="SELECCIONAR">
                    <input
                      type="radio"
                      :value="dato.id_persona"
                      :id="dato.id_persona"
                      v-model="state.formData.id_persona"
                      @input="getSection(dato.id_recinto_penitenciario)"
                    />
                  </td>
                </tr>
              </tbody>
              <span class="text-danger" v-if="v$.formData.id_persona.$error">
                Seleccione una Persona Privada de Libertad
              </span>
            </table>
          </div>
          <div
            v-if="
              state.formData.tipo_visita == 'PERSONAL' && resultados.length > 0
            "
            class="row"
          >
            <!-- seccion recinto -->
            <div class="col-md-6 mt-3">
              <label class="form-label required">Sección:</label>
              <select
                v-model="state.formData.id_seccion"
                class="form-select fuente"
                aria-label="select"
                :disabled="state.formData.id_persona === ''"
                :class="{ 'is-invalid': v$.formData.id_seccion.$error }"
              >
                <option
                  v-for="(list, key) in secciones.respuesta"
                  :value="list.id_seccion"
                  :key="key"
                >
                  {{ list.nombre_seccion }}
                </option>
              </select>
              <span class="text-danger" v-if="v$.formData.id_seccion.$error">
                El registro Sección es requerido
              </span>
            </div>
            <!-- parentesco -->
            <div class="col-md-6 mt-3">
              <label class="form-label required">Parentesco:</label>
              <select
                v-model="state.formData.id_parentesco"
                class="form-select fuente"
                :class="{ 'is-invalid': v$.formData.id_parentesco.$error }"
                aria-label="select"
                @change="esOtroParentesco(state.formData.id_parentesco)"
              >
                <option
                  v-for="(list, key) in relationshipList"
                  :value="list.id_parentesco"
                  :key="key"
                >
                  {{ list.nombre_parentesco }}
                </option>
              </select>
              <span class="text-danger" v-if="v$.formData.id_parentesco.$error">
                El registro Parentesco es requerido
              </span>
            </div>
          </div>
          <div
            v-if="
              state.formData.tipo_visita == 'INSTITUCIONAL' ||
              (state.formData.tipo_visita == 'PERSONAL' &&
                resultados.length > 0)
            "
            class="row"
          >
            <!-- si no tiene parentesco (OTRO) -->
            <div v-if="esOtro" class="col-md-6 mt-3">
              <label
                v-if="state.formData.tipo_visita == 'PERSONAL'"
                class="form-label required"
                >Relación:</label
              >
              <label v-else class="form-label required">Cargo:</label>
              <input
                type="text"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.relacion.$error }"
                style="text-transform: uppercase"
                id="otro"
                v-model.trim="state.formData.relacion"
                v-uppercase
              />
              <span class="text-danger" v-if="v$.formData.relacion.$error">
                El registro
                {{
                  state.formData.tipo_visita === "PERSONAL"
                    ? "Relación"
                    : "Cargo"
                }}
                es requerido
              </span>
            </div>
            <div v-if="esOtro" class="col-md-6 mt-3">
              <label class="form-label required">Institución:</label>
              <input
                type="text"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.institucion.$error }"
                style="text-transform: uppercase"
                id="otro"
                v-model.trim="state.formData.institucion"
                v-uppercase
              />
              <span class="text-danger" v-if="v$.formData.institucion.$error">
                El registro Institución es requerido
              </span>
            </div>
            <!-- teléfono -->
            <div class="col-md-6 mt-3">
              <label class="form-label">N° Teléfono:</label>
              <input
                type="number"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.telefono_movil.$error }"
                style="text-transform: uppercase"
                id="telefono"
                v-model="state.formData.telefono_movil"
              />
              <span
                class="text-danger"
                v-if="v$.formData.telefono_movil.$error"
              >
                El registro N° Teléfono es requerido
              </span>
            </div>
            <!-- motivo visita -->
            <div class="col-md-12 mt-3">
              <label class="form-label required">Motivo Visita:</label>
              <textarea
                type="text"
                class="form-control fuente"
                :class="{ 'is-invalid': v$.formData.motivo_visita.$error }"
                style="text-transform: uppercase"
                id="motivo_visita"
                v-model.trim="state.formData.motivo_visita"
                v-uppercase
              />
              <span class="text-danger" v-if="v$.formData.motivo_visita.$error">
                El registro Motivo Visita es requerido
              </span>
            </div>
            <!-- observación ingreso -->
            <div class="col-md-12 mt-3">
              <label class="form-label">Observación ingreso:</label>
              <textarea
                type="text"
                class="form-control fuente"
                style="text-transform: uppercase"
                id="observacion_ingreso"
                v-model.trim="state.formData.observacion_ingreso"
                v-uppercase
              />
            </div>
          </div>
          <p class="m-10" align="right">
            <button
              v-if="!isLoading"
              :disabled="
                state.formData.tipo_visita == 'PERSONAL' &&
                resultados.length === 0
              "
              class="btn btn-primary"
              @click="registerVisit()"
            >
              Registrar
            </button>
            <button
                v-else
                class="btn btn-primary"
                disabled
              >
                Por favor espere ...
              </button>
          </p>
        </div>
        <div v-if="visitaActiva" class="alert alert-danger mt-5">
          <strong>¡Atención!</strong> La persona cuenta con una
          <strong>VISITA ACTIVA</strong> en el Módulo de Visitas del Sistema
          Estado Digital ED4 - Régimen Penitenciario.
        </div>
      </div>
    </div>
  </div>
  <!-- loader -->
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    :height="100"
    :width="100"
  ></loading>
  <pictureCapture ref="modal" @save-image="addImage"></pictureCapture>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  onMounted,
  computed,
  watchEffect,
} from "vue";
import useAuth from "@/auth/composables/useAuth";
import filiation from "@/filiation/composables/useFiliation";
import visits from "@/visits/composables/useVisits";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import formatDate from "@/helpers/formatDate";
import Loading from "vue-loading-overlay";
import Datepicker from "vue3-date-time-picker";
import "vue3-date-time-picker/dist/main.css";
import date from "date-and-time";
import { formatISO } from "date-fns";
import countries from "@/core/data/countries";
import formatDateWithHours from "@/helpers/formatDateWithHours";
import "vue-loading-overlay/dist/vue-loading.css";
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import pictureCapture from "@/views/pictures/pictureCapture.vue";
import personImg from "@/assets/person.png";

export default defineComponent({
  name: "register-visit",
  components: { Loading, Datepicker, pictureCapture },

  setup() {
    const router = useRouter();

    const dialog = ref(false);
    const modal = ref(null);
    const documentTypeList = ref([]);
    const isLoading = ref(false);
    const isDisabled = ref(false);
    const sinRegistroSegip = ref(false);
    const dato_busqueda = ref("");
    const resultados = ref([]);
    const relationshipList = ref([]);
    const registroManual = ref(false);
    const esOtro = ref(false);
    const visitaActiva = ref("");
    const esSeleccionado = ref([]);
    const secciones = ref([]);
    const segipToken = ref(null);

    const now = new Date();
    const pattern = date.compile("MM DD YYYY");
    const currentDate = date.format(now, pattern);

    const { id_recinto } = useAuth();

    const {
      getSectionPpl,
      getDataVisit,
      valueToSearch,
      register,
      checkRestriction,
    } = visits();

    const { documentType, relationships } = filiation();

    const state = reactive({
      formData: {
        tipo_visita: "PERSONAL",
        tipo_documento: 1,
        nro_documento: "",
        complemento: "",
        genero: "",
        fecha_nacimiento: "",
        nombres: "",
        primer_apellido: "",
        segundo_apellido: "",
        pais: "",
        departamento: "",
        telefono_movil: "",
        imagen_segip: personImg,
        id_persona: "",
        fecha_visita: formatISO(new Date(), "ppp"),
        id_parentesco: "",
        id_visita: "",
        id_recinto_penitenciario: "",
        id_seccion: "",
        relacion: "",
        motivo_visita: "",
        institucion: "",
        observacion_ingreso: "",
      },
    });

    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 9000,
      timerProgressBar: true,
    });

    const rules = computed(() => {
      return {
        formData: {
          tipo_visita: { required },
          nro_documento: { required },
          nombres: { required },
          segundo_apellido: { required },
          fecha_nacimiento: { required },
          genero: { required },
          pais: { required },
          id_persona: {
            required: requiredIf(function () {
              return state.formData.tipo_visita === "PERSONAL";
            }),
          },
          id_seccion: {
            required: requiredIf(function () {
              return state.formData.tipo_visita === "PERSONAL";
            }),
          },
          id_parentesco: {
            required: requiredIf(function () {
              return state.formData.tipo_visita === "PERSONAL";
            }),
          },
          relacion: {
            required: requiredIf(function () {
              return esOtro.value === true;
            }),
          },
          institucion: {
            required: requiredIf(function () {
              return esOtro.value === true;
            }),
          },
          telefono_movil: { required },
          motivo_visita: { required },
        },
      };
    });

    const v$ = useVuelidate(rules, state);

    const openModalPicture = () => {
      dialog.value = true;
      modal.value.showModal(dialog.value, 0);
    };

    const addImage = (value) => {
      if (!value) return;

      state.formData.imagen_segip = value.formData.picture;
      dialog.value = false;
    };

    const format = (value) => {
      if (value === "" || value === null) return;

      return formatDate(value);
    };

    const formatDateAndHours = (value) => {
      return formatDateWithHours(value);
    };

    const listDocumentTypes = async () => {
      const { data } = await documentType();
      documentTypeList.value = data;
    };

    const relationship = async () => {
      const { data } = await relationships();
      relationshipList.value = data;
    };

    const requiredDisabled = (tipo_documento) => {
      const found = documentTypeList.value.filter(function (element) {
        return element.id_tipo_documento_identidad == tipo_documento;
      });

      if (found.length > 0) {
        registroManual.value =
          found[0].nombre_tipo_documento_identidad !== "CARNET DE IDENTIDAD";
      }
    };

    const esOtroParentesco = (val) => {
      const result = relationshipList.value.find(function (parentesco) {
        return parentesco.id_parentesco === val;
      });

      if (!result) return;

      esOtro.value = result.nombre_parentesco === "OTRO";
    };

    const obtenerDataResponse = (response) => {
      if (response && response.data) return response.data;
      return response;
    };

    const obtenerRespuestaPartial = (data) => {
      if (!data) return null;

      if (data.type === "partial") return data;
      if (data.data && data.data.type === "partial") return data.data;
      if (data.respuesta && data.respuesta.type === "partial") return data.respuesta;

      return null;
    };

    const obtenerTokenPartial = (data) => {
      if (!data) return null;

      return (
        data.token ||
        (data.data && data.data.token) ||
        (data.respuesta && data.respuesta.token) ||
        null
      );
    };

    const cargarDatosDesdeSegip = (respuesta) => {
      state.formData.genero = respuesta.Genero || "";
      state.formData.fecha_nacimiento = respuesta.FechaNacimiento || "";
      state.formData.nombres = respuesta.Nombres || "";
      state.formData.primer_apellido = respuesta.PrimerApellido || "";
      state.formData.segundo_apellido = respuesta.SegundoApellido || "";
      state.formData.pais = respuesta.LugarNacimientoPais || "";
      state.formData.departamento = respuesta.LugarNacimientoDepartamento || "";

      state.formData.imagen_segip =
        respuesta.Fotografia !== undefined && respuesta.Fotografia !== null
          ? "data:image/jpeg;base64," + respuesta.Fotografia
          : personImg;
    };

    const cargarDatosDesdeVisita = (persona) => {
      state.formData.genero = persona.visita_genero || "";
      state.formData.fecha_nacimiento = persona.visita_fecha_nacimiento || "";
      state.formData.nombres = persona.visita_nombres || "";
      state.formData.primer_apellido = persona.visita_primer_apellido || "";
      state.formData.segundo_apellido = persona.visita_segundo_apellido || "";
      state.formData.pais = persona.visita_pais || "";
      state.formData.departamento = persona.visita_departamento || "";
      state.formData.imagen_segip = persona.visita_imagen_segip || personImg;
      state.formData.id_visita = persona.id_visita || "";
      state.formData.telefono_movil = persona.visita_telefono_movil || "";
    };

    const mostrarConfirmacionIdentidad = async (respuesta) => {
      const nombres = respuesta.Nombres || "";
      const primerApellido = respuesta.PrimerApellido || "";
      const segundoApellido = respuesta.SegundoApellido || "";

      return Swal.fire({
        title: "Confirmar identidad",
        html: `
          <div style="text-align:left">
            <p>¿La persona consultada es la correcta?</p>
            <hr>
            <p><b>Nombres:</b> ${nombres}</p>
            <p><b>Primer apellido:</b> ${primerApellido}</p>
            <p><b>Segundo apellido:</b> ${segundoApellido}</p>
          </div>
        `,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, es correcto",
        cancelButtonText: "No, cancelar",
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-light-danger",
        },
      });
    };

    const validarRestriccion = async () => {
      const restrictionResponse = await checkRestriction({
        nro_documento: state.formData.nro_documento,
        complemento:
          state.formData.complemento !== "" ? state.formData.complemento : 0,
        id_recinto: id_recinto.value,
      });

      const restrictionData = restrictionResponse.data;

      if (!restrictionData.tiene_restriccion) {
        return false;
      }

      Swal.fire({
        title: restrictionData.es_indefinido
          ? "Restricción Indefinida"
          : restrictionData.tiempo_restante > 0
            ? restrictionData.tiempo_restante + " días restantes"
            : "Restricción Cumplida",
        html: String(restrictionData.respuesta),
        icon: "info",
        buttonsStyling: false,
        confirmButtonText: "Continuar",
        customClass: {
          confirmButton: "btn fw-bold btn-light-primary",
        },
      });

      resetData();
      return true;
    };

    const consultarVisitaSegip = async (type) => {
      if (type === "complete") {
        if (!segipToken.value) {
          return {
            error: true,
            message: "No existe token para completar la consulta SEGIP.",
          };
        }

        return getDataVisit(
          {
            token: segipToken.value,
          },
          "complete"
        );
      }

      return getDataVisit(
        {
          nro_documento: state.formData.nro_documento,
          complemento: state.formData.complemento,
          tipo_documento: state.formData.tipo_documento,
        },
        "partial"
      );
    };

    const manejarRespuestaPartial = async (data) => {
      const respuestaPartial = obtenerRespuestaPartial(data);

      if (!respuestaPartial) {
        return false;
      }

      segipToken.value = obtenerTokenPartial(data);

      if (!segipToken.value) {
        Toast.fire({
          icon: "error",
          title: "No se recibió token para completar la consulta SEGIP.",
        });

        return true;
      }

      isLoading.value = false;

      const confirmResult = await mostrarConfirmacionIdentidad(respuestaPartial);

      if (confirmResult.isConfirmed) {
        await searchData("complete");
        return true;
      }

      segipToken.value = null;

      Toast.fire({
        icon: "info",
        title: "Consulta cancelada por el usuario.",
      });

      resetData();
      return true;
    };

    const manejarRespuestaSinOk = (data) => {
      if (typeof data.respuesta === "string") {
        if (data.respuesta === "No se encontró el registro") {
          Toast.fire({
            icon: "info",
            title:
              "No se encontró el registro, por favor verifique el número de CI",
          });

          sinRegistroSegip.value = true;
          resetData();
          return true;
        }

        if (data.respuesta === "ES EXTRANJERO") {
          Toast.fire({
            icon: "info",
            title: "Registre los datos de la persona extranjera.",
          });

          registroManual.value = true;
          sinRegistroSegip.value = false;
          return true;
        }

        if (data.respuesta === "ES MENOR DE EDAD SIN CI") {
          Toast.fire({
            icon: "info",
            title: "Registre los datos de la o el menor de edad.",
          });

          registroManual.value = true;
          sinRegistroSegip.value = false;
          return true;
        }

        Toast.fire({
          icon: "error",
          title: data.respuesta,
        });

        return true;
      }

      const respuesta = data.respuesta;

      Toast.fire({
        icon: "info",
        title:
          (respuesta.Nombres || "") +
          " " +
          (respuesta.PrimerApellido || "") +
          " " +
          (respuesta.SegundoApellido || "") +
          " no registra visitas en el Sistema ED 04 - Régimen Penitenciario.",
      });

      isDisabled.value = true;
      sinRegistroSegip.value = false;

      cargarDatosDesdeSegip(respuesta);

      return true;
    };

    const manejarRespuestaConVisitas = (data) => {
      const visitaSinSalida = data.respuesta.some(function (fecha_salida) {
        return fecha_salida.fecha_visita_salida === null;
      });

      visitaActiva.value = visitaSinSalida;

      isDisabled.value = true;
      sinRegistroSegip.value = false;

      const persona = data.respuesta[0];

      cargarDatosDesdeVisita(persona);

      resultados.value = data.visitas;

      let value = "";

      if (data.visitas.length === 0) {
        value =
          persona.visita_nombres +
          " " +
          persona.visita_primer_apellido +
          " " +
          persona.visita_segundo_apellido +
          " no registra visitas en el Sistema Estado Digital 04 - Régimen Penitenciario";
      } else if (data.visitas.length === 1) {
        value =
          persona.visita_nombres +
          " " +
          persona.visita_primer_apellido +
          " " +
          persona.visita_segundo_apellido +
          " registra " +
          data.visitas.length +
          " visita en el Sistema Estado Digital 04 - Régimen Penitenciario";
      } else {
        value =
          persona.visita_nombres +
          " " +
          persona.visita_primer_apellido +
          " " +
          persona.visita_segundo_apellido +
          " registra " +
          data.visitas.length +
          " visitas en el Sistema Estado Digital 04 - Régimen Penitenciario";
      }

      Toast.fire({
        icon: "info",
        title: value,
      });
    };

    const searchData = async (type = "partial") => {
      try {
        isLoading.value = true;

        if (type === "partial") {
          const tieneRestriccion = await validarRestriccion();
          if (tieneRestriccion) {
            return;
          }
        }

        const visitResponse = await consultarVisitaSegip(type);

        if (visitResponse && visitResponse.error) {
          Toast.fire({
            icon: "error",
            title: visitResponse.message,
          });

          return;
        }

        const data = obtenerDataResponse(visitResponse);
        const fuePartial = await manejarRespuestaPartial(data);

        if (fuePartial) {
          return;
        }

        segipToken.value = null;

        if (data.ok === false) {
          manejarRespuestaSinOk(data);
          return;
        }

        manejarRespuestaConVisitas(data);
      } catch (error) {
        console.error(error);

        segipToken.value = null;

        let message = "Ocurrió un error inesperado";

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.respuesta
        ) {
          message = error.response.data.respuesta;
        } else if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          message = error.response.data.message;
        } else if (error && error.message) {
          message = error.message;
        }

        Toast.fire({
          icon: "error",
          title: message,
        });
      } finally {
        isLoading.value = false;
      }
    };

    const getSection = async (id_recinto) => {
      const { data } = await getSectionPpl(id_recinto);
      state.formData.id_recinto_penitenciario = id_recinto;
      secciones.value = data;
    };

    const registerVisit = async () => {
      const isFormCorrect = await v$.value.$validate();
      if (!isFormCorrect) return;

      try {
        isLoading.value = true;

        const { data } = await register(state.formData);

        if (data.ok) {
          Swal.fire({
            title: "¡Realizado!",
            text: "Registro de visita realizado correctamente",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Continuar",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          });

          router.push({ name: "list_visits" });
          resetData();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      } finally {
        isLoading.value = false;
      }
    };

    const resetData = () => {
      visitaActiva.value = "";
      isDisabled.value = false;
      segipToken.value = null;
      sinRegistroSegip.value = false;
      state.formData.tipo_visita = "PERSONAL";
      state.formData.nro_documento = "";
      state.formData.complemento = "";
      state.formData.genero = "";
      state.formData.fecha_nacimiento = "";
      state.formData.nombres = "";
      state.formData.primer_apellido = "";
      state.formData.segundo_apellido = "";
      state.formData.pais = "";
      state.formData.departamento = "";
      state.formData.imagen_segip = personImg;
      state.formData.telefono_movil = "";
      state.formData.id_persona = "";
      state.formData.id_visita = "";
      state.formData.id_recinto_penitenciario = "";
      state.formData.id_seccion = "";
      state.formData.id_parentesco = "";
      state.formData.motivo_visita = "";
      state.formData.observacion_ingreso = "";

      resultados.value = [];
      registroManual.value = false;
      visitaActiva.value = "";
      v$.value.$reset();
    };

    const searchPpl = async (value) => {
      try {
        isLoading.value = true;

        const { data } = await valueToSearch(value.toUpperCase());

        if (!data.ok) {
          Toast.fire({
            icon: "info",
            title: "No existen coincidencias con los datos ingresados",
          });

          return;
        }

        resultados.value = data.respuesta;
      } catch (error) {
        console.error(error);

        Toast.fire({
          icon: "error",
          title: "Error buscando Persona Privada de Libertad.",
        });
      } finally {
        isLoading.value = false;
      }
    };

    const checkFieldEmpty = (e, dato, type) => {
    if (type === "nro_doc") {
      visitaActiva.value = "";
      sinRegistroSegip.value = false;
      isDisabled.value = false;
      resultados.value = [];
      segipToken.value = null;

      state.formData.genero = "";
      state.formData.fecha_nacimiento = "";
      state.formData.nombres = "";
      state.formData.primer_apellido = "";
      state.formData.segundo_apellido = "";
      state.formData.pais = "";
      state.formData.departamento = "";
      state.formData.imagen_segip = personImg;
      state.formData.id_visita = "";
      state.formData.telefono_movil = "";

      if (dato === "") {
        resetData();
        return;
      }
    } else {
      resultados.value = [];
    }

    state.formData.id_persona = "";
  };

    const countriesOrdered = computed(() =>
      countries[0].result.sort(function (a, b) {
        if (a.name > b.name) return 1;
        if (a.name < b.name) return -1;
        return 0;
      })
    );

    onMounted(() => {
      setCurrentPageBreadcrumbs("Registro de Visitas", ["Visitas"]);
      listDocumentTypes();
      relationship();
    });

    watchEffect(() => {
      if (state.formData.tipo_visita === "INSTITUCIONAL") {
        state.formData.id_recinto_penitenciario = JSON.parse(
          window.localStorage.user
        ).cod_recinto_penitenciario;

        esOtro.value = true;
      } else {
        esOtro.value = false;
      }
    });

    return {
      isDisabled,
      state,
      v$,
      format,
      documentTypeList,
      requiredDisabled,
      isLoading,
      sinRegistroSegip,
      dato_busqueda,
      searchPpl,
      resultados,
      relationshipList,
      currentDate,
      formatDateAndHours,
      checkFieldEmpty,
      registroManual,
      countriesOrdered,
      searchData,
      registerVisit,
      esOtroParentesco,
      esOtro,
      esSeleccionado,
      secciones,
      resetData,
      getSection,
      visitaActiva,
      openModalPicture,
      modal,
      dialog,
      addImage,
    };
  },

  directives: {
    uppercase: {
      updated: function (el) {
        el.value = el.value.toUpperCase();
        el.dispatchEvent(new Event("input"));
      },
    },
  },
});
</script>

<style scoped>
:root {
  --color-text: #616161;
  --color-text-btn: #ffffff;
  --card1-gradient-color1: #f12711;
  --card1-gradient-color2: #f5af19;
  --card2-gradient-color1: #7f00ff;
  --card2-gradient-color2: #e100ff;
  --card3-gradient-color1: #3f2b96;
  --card3-gradient-color2: #a8c0ff;
  --card4-gradient-color1: #11998e;
  --card4-gradient-color2: #38ef7d;
}
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
.card-wrap {
  background: #fff;
  border-radius: 20px;
  border: 3px solid rgb(221, 221, 221);
  overflow: hidden;
  color: var(--color-text);
  /* box-shadow: rgb(87, 174, 255) 10px 10px 10px,
    rgba(199, 192, 192, 0.23) 0px 1px 1px; */
  cursor: auto;
  transition: all 0.2s ease-in-out;
  padding: 10px;
}
p.round3 {
  border: 1px solid;
  border-radius: 5px;
  border-left-width: 7px;
  border-left-color: #037915;
  padding: 10px;
}
p.round4 {
  border: 1px solid;
  border-radius: 5px;
  border-left-width: 7px;
  border-left-color: #ff0000;
  padding: 10px;
}
table {
  width: auto;
  border-collapse: collapse;
  margin: 20px auto;
}

/* Zebra striping */
tr:nth-of-type(odd) {
  background: #eee;
}

th {
  background: #3498db;
  color: white;
  font-weight: bold;
}

td,
th {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: center;
  font-size: 12px;
}
/* 
Max width before this PARTICULAR table gets nasty
This query will take effect for any screen smaller than 760px
and also iPads specifically.
*/
@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  table {
    width: 100%;
  }

  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    border: 1px solid #ccc;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 50%;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
    /* Label the data */
    content: attr(data-column);

    color: #000;
    font-weight: bold;
  }
}
</style>
